  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ lang?.general_data }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
     <table class="table table-striped table-hover table-bordered" >
        <tbody>
          <tr>           
            <td width="30%">{{lang?.examination}}</td>
            <td>{{ general?.examination }}</td>
          </tr>

          <tr>
            <td width="30%">{{lang?.description}}</td>
            <td>{{ general?.description }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang?.employees }}</td>
            <td>{{ general?.employees }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang?.doctor }}</td>
            <td>{{ general?.doctor }} </td>
          </tr>

          <tr>
            <td width="30%">{{ lang?.notes }}</td>
            <td>{{ general?.notes }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang?.attachments }}</td>
            <td>
              {{ general?.attachments }}
            </td>
          </tr>

          <tr>
            <td width="30%">{{ lang?.referenceEmail }}</td>
            <td>
              <div *ngIf="general && general?.ref_email.length > 0">
                <p *ngFor="let email of general?.ref_email"> {{ email }} </p>
              </div>
            </td>
          </tr>

        </tbody>
      </table>

  </div>

